var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#3D8A68"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5004 20.125L20.2629 23.35H19.9879C18.5922 23.0487 17.2486 22.5433 16.0004 21.85C14.7671 21.1856 13.6383 20.3432 12.6504 19.35C10.6319 17.3293 9.26109 14.7531 8.71289 11.95V11.6625L11.8629 8.5L15.2254 11.825L13.3754 13.675C13.5374 14.0092 13.7168 14.3346 13.9129 14.65L13.1504 15.4125C12.8046 14.8931 12.5035 14.3453 12.2504 13.775L12.1004 13.5L13.7129 11.825L11.8629 9.9625L9.81289 12.0125C10.077 13.2042 10.4973 14.3558 11.0629 15.4375C11.6886 16.6001 12.4802 17.6655 13.4129 18.6C14.3261 19.52 15.3708 20.2993 16.5129 20.9125C17.5928 21.4821 18.745 21.9026 19.9379 22.1625L22.0004 20.0875L20.1504 18.2625L18.5004 19.8875L18.1879 19.75C16.9027 19.1654 15.7371 18.3474 14.7504 17.3375C14.5124 17.0995 14.2871 16.8491 14.0754 16.5875L14.8254 15.8375C15.0371 16.0991 15.2624 16.3495 15.5004 16.5875C16.3315 17.416 17.2946 18.1003 18.3504 18.6125L20.1504 16.75L23.5004 20.125Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.25fbe3774bd58339c23d05f4dde9e7ac.svg";
export { ForwardRef as ReactComponent };